<template>
   <v-dialog
	  v-model="showPhotoViewer"  :fullscreen="$vuetify.breakpoint.xsOnly ? true : false"     
	  width="50%">
		<v-toolbar>                   
			<v-toolbar-title class="headline">               
				{{selectedBuilding && selectedBuilding.name}} - {{selectedRoom && selectedRoom.number}} 
			</v-toolbar-title>                                            
			<v-spacer></v-spacer>
			<v-btn icon @click="setShowPhotoViewer(false)">
				<v-icon>close</v-icon>
			</v-btn>
		</v-toolbar>
		<v-card class="photoviewport" style="overflow: auto">
			<v-container grid-list-md fluid>
			  	<v-layout row wrap>
					<v-flex
					  v-for="(photo, index) in photos"
					  :key="index"
					  xs4>
						  <v-card flat tile >
							<v-dialog max-height="90vh" v-model="dialog[index]" >
								<template v-slot:activator="{ on }" >
									<v-img v-if="photo.reviewed || isOwner(photo)" contain :src=photo.url v-on="on" >
										<span class="headline" v-if="!photo.reviewed" style="position: absolute; left: 10px; top: 3px;" >
											Pending
										</span>
										<div style="position: absolute; right: 3px; top: 3px; background-color: #333333; opacity: 0.6">
											<v-icon  
												color="white"
												v-if="showElevatedControls(photo)"
												@click="delDialog[index]=true">
												delete
											</v-icon>
										</div>
										
										<v-dialog v-model="delDialog[index]" max-width="300">
											<v-card class="pl-2 pt-1 pr-2">
										        <v-card-title class="headline">Confirm Delete</v-card-title>
										        <v-divider></v-divider>
										        <v-card-text class="pt-4 body-2">Delete Photo?</v-card-text>
										        <v-card-actions>
										          	<v-spacer></v-spacer>
										          	<v-btn color="green darken-1" flat @click.native="cancel">No</v-btn>
										          	<v-btn color="green darken-1" flat 
										          		@click.native="delPhoto(photo)">Yes
										      	 	 </v-btn>
										        </v-card-actions>
									      	</v-card>
								    	</v-dialog>

									</v-img>
									<v-layout style="background-color: #DDDDDD;" class="mx-0 px-2 py-1" justify-space-between>
										<v-flex>
											<v-tooltip bottom>
											<div slot="activator" v-show="!editOwner[index]" @click="showEditOwner(index, photo)" style="color: #222222; cursor: pointer;" >
												{{photo.created.slice(0,10)}}<br>
												{{photo.name}}
											</div>
											Edit Owner
											</v-tooltip>
											<v-layout column v-if="editOwner[index]">
												<v-layout>
													<EmployeeAutocomplete
														:dark="true"
														label="Select Employee"
														:singleline="true" v-on:return-employee="setOwner"
													/>

													<v-icon small 
														style="margin-left:5px;"
														@click="editOwner=[]">close
													</v-icon>

													<v-icon small @click="savePhoto(photo)"
														style="position: relative ; left: 10px;">save</v-icon>
												</v-layout>
												
											</v-layout>
										</v-flex>
										<v-flex class="text-xs-right">
											<v-tooltip right>
											<div slot="activator" v-show="!editTagsDialogs[index] && !editOwner[index]" @click="showEditTagsDialogs(index, photo)" style="color: #333333; cursor:pointer;">{{photo.tags || `+`}}</div>
											Edit Tags

											</v-tooltip>
											<v-layout column v-if="editTagsDialogs[index]">
												<v-layout>
													<v-flex>
														<v-radio-group v-model="radioGroup">
													      <v-radio label="View of Front" value="Front"></v-radio>
													      <v-radio label="View of Back" value="Back"></v-radio>
													      <v-radio label="Layout" value="Layout"></v-radio>
														  <v-radio label="Sign" value="Sign"></v-radio>
													    </v-radio-group> 
													    <!-- <v-text-field box persistent-hint
															hint="Enter Tags, comma seperated" 
															v-model="photo.tags">
													    </v-text-field>	 -->
													</v-flex>
													
													<v-icon small 
														style="position: relative; top: -2px;" 
														@click="editTagsDialogs=[]">close</v-icon>
												</v-layout>
												<v-layout justify-end>
													<v-icon small @click="savePhoto(photo)"
													style="position: relative ;  bottom: 15px; right: 0px;">save</v-icon>
												</v-layout>
											</v-layout>
										</v-flex>
									</v-layout> 
								</template>
							  	<v-img max-height="90vh" contain :src=photo.url @click="dialog=[]" />	
							</v-dialog>
						  </v-card>
					</v-flex>
			  	</v-layout>
			</v-container>
		</v-card>
	</v-dialog>
</template>

<script>
import Vuex from 'vuex'
import Vue from 'vue'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { NETID_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'
import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'

export default {
name: 'PhotoViewerDialog',

components: { EmployeeAutocomplete },

data () {
	return {
		dialog: [],
		delDialog: [],
		photos: [],
		editTagsDialogs: [],
		editOwner: [],
		classRooms: [],
		radioGroup: null,
		employeeID: null,
		currentPhoto: null
	}
},

watch: {
	showPhotoViewer (val) { if (val) { this.refreshPhotos() } },
},

computed: {
	...mapState({
				selectedBuilding: state => state.space.selectedBuilding,
				selectedRoom: state => state.space.selectedRoom,
				isSuperUser: state => state.user.isSuperUser,
				showPhotoViewer: state => state.ui.showPhotoViewer,
				userProfile: state => state.user.userProfile,
	}),
	...mapGetters([   'hasRole']),

	showPhotoViewer: {
	    get () {
	      return this.$store.state.ui.showPhotoViewer
	    },

	    set (value) {
	        this.setShowPhotoViewer()
	    }
	},
},

created: async function () {	
	// Grab classRooms so that can filter using this list of roomKeys from CTS rooms endpoint
	let rooms = await this.fetchCtsRooms()
	rooms.forEach((room) => { this.classRooms.push(room.roomKey) })
},

methods : {
	...mapMutations(['setShowPhotoViewer',]),
	...mapActions(['fetchFullRoom', 'deletePhoto', 'fetchRoomPhotos', 'updatePhotos', 'fetchCtsRooms']),

	delPhoto: function(photo) {
		console.log("Delete Photo")
		this.deletePhoto(photo.key).then(() => this.refreshPhotos() )
		this.delDialog=[]
		this.dialog=[]
	},

	cancel: function () {
		this.delDialog=[]
		this.dialog=[]
	},

	isClassRoomPhoto: function (photo) { 
    	if (this.classRooms.includes(photo.roomKey)) { return true }
    },

	showElevatedControls(photo) {
		if (this.isOwner(photo))														{ return true }
		//if (this.hasRole("CTS") && this.isClassRoomPhoto(photo)) 		{ return true }	// Redundant.  Being deprecated 8/30/21
		if (this.hasRole("Photos - Classroom") && this.isClassRoomPhoto(photo)) 		{ return true }
		if (this.hasRole("Photos - Sign Shop") && photo.tags && photo.tags.includes("Sign")) 	{ return true }
	},

	isOwner: function (photo) {
		let empID = this.userProfile.employeeID
		if (this.isSuperUser || photo.employeeID == empID) { return true}
	},

	refreshPhotos: function () {
		this.fetchRoomPhotos(this.selectedRoom.roomKey).then((data) => this.photos=data )
	},

	savePhoto (photo) {
		return new Promise( async (resolve, reject) => {
			this.editTagsDialogs = []
			this.editOwner = []

			if (this.radioGroup) {
					photo.tags = []
					photo.tags.push(this.radioGroup)
				}
			this.radioGroup = null

			let payload=[]

			if(this.employeeID != null) {
				photo.employeeID = this.employeeID
			}

			payload.push(photo)


			//console.log("Update Photo")
			//console.log(payload)
			await this.updatePhotos(payload)  // takes an array

			this.currentPhoto = null
			this.employeeID = null
			resolve()
		})
	},

	niceTags(stringArray) {
		return stringArray && stringArray.join(", ")
	},

	showEditTagsDialogs (index, photo) {
		if (this.isOwner(photo)) { Vue.set(this.editTagsDialogs, index, true) }
	},

	showEditOwner (index, photo) {
		if (this.isOwner(photo)) {
			this.editOwner = []
				Vue.set(this.editOwner, index, true)
				this.currentPhoto = photo
			}
	},

	async setOwner(employee){
		this.employeeID = employee.employeeID
		await this.savePhoto(this.currentPhoto)
		this.refreshPhotos()
	}

},

}

</script>


<style>

.photoviewport {
height: 80vh !important ;
}

</style>



// WEBPACK FOOTER //
// src/components/PhotoViewerDialog.vue